import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import { SceneEmail } from '../SceneEmail';

const BANNER_IMAGE_MAP: Record<string, { pc: string; pad: string; h5: string }> = {
    us: {
        pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767666828052-7i1iwm-compressed-home-carousel-banner.jpg',
        pad: 'https://websiteoss.ecoflow.com/figma-uploads/1769395235390-aioc93-compressed-home-carousel-banner.jpg',
        h5: 'https://websiteoss.ecoflow.com/figma-uploads/1769395235390-aioc93-compressed-home-carousel-banner.jpg',
    },
    au: {
        pc: 'https://websiteoss.ecoflow.com/figma-uploads/1785231147593-6fra3c-compressed-home-carousel-banner.webp',
        pad: 'https://websiteoss.ecoflow.com/figma-uploads/1785231339795-o8526c-compressed-mob-home-carousel-banner.webp',
        h5: 'https://websiteoss.ecoflow.com/figma-uploads/1785231339795-o8526c-compressed-mob-home-carousel-banner.webp',
    },
};

export default function Banner() {
    const { t } = useLang('powerbackup');
    const { locale } = getLocal();
    const images = BANNER_IMAGE_MAP[locale] || BANNER_IMAGE_MAP.us;

    return (
        <div className={`${styles.Banner} GtmModuleData-section`}>
            <EcoImg pc={images.pc} pad={images.pad} h5={images.h5} />

            <div className="wrapper">
                <div className="title">{t('secA_title')}</div>
                <div className="desc-box">
                    <SceneEmail
                        theme="white"
                        type="BATTERY_BACKUP"
                        title={t('secA_title')}
                        subscribeData={
                            locale === 'au'
                                ? {
                                      source: 'WEB_NEW_PRODUCT_SUB',
                                      contactListId: '1388453392',
                                      fields: [
                                          { type: 'single', id: '4433', value: 1, overwrite: true },
                                          { type: 'single', id: '31', value: 1, overwrite: true },
                                          { type: 'multiple', id: '9537', value: [23], overwrite: false },
                                      ],
                                  }
                                : undefined
                        }
                    />
                </div>
            </div>
        </div>
    );
}
